import { Component, ElementRef, EventEmitter, HostListener, inject, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonStore, RxStore } from 'src/app/store';
import { PDMPVendorEnums } from 'src/app/models/system-settings.enum';
import { LogicoyService } from 'src/app/services/logicoy.service';
import { CommonService, LoaderService, NotesLogService } from 'src/app/services';
import { CommonUtil, NRxSaveUtils } from 'src/app/utils';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { NotesMainCat } from 'src/app/models/notes.enum';
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
import { v4 as uuid } from 'uuid';
import { MsgConfig } from 'src/app/app.messages';
@Component({
  selector: 'app-pdmp-vendors-display',
  templateUrl: './pdmp-vendors-display.component.html',
  styleUrls: ['./pdmp-vendors-display.component.scss']
})
export class PdmpVendorsDisplayComponent {
  modelRef: any;
  _modelService = inject(NgbModal);
  @Input() patientInfo: any;
  @Input() rxType: string;
  @ViewChild('pdmpVendorsDisplay', { static: true }) pdmpVendorsDisplay: any;
  pdmpIframeUrl: any;
  _sanitizer = inject(DomSanitizer);
  @Output() closeModalEvent = new EventEmitter<any>();
  pdmpVendorData: any;
  pdmpVendorDetails: any;
  vendorTypeId = PDMPVendorEnums.Logicoy;
  pdmpVendorEnums = PDMPVendorEnums;
  vendorUrl: string = '';
  private _logicoy = inject(LogicoyService);
  private _cmnService = inject(CommonService);
  private _loadrServ = inject(LoaderService);
  narxInformation: any;
  @Input() openType: string;
  @Input() prescRefillId: number | string;
  @Input() rxInfo: any;
  trackLogs: any[]=[];
  @Input() frmPatOrRxHistory: boolean = false;
  private _rxStore = inject(RxStore);
  private _cmnStore = inject(CommonStore);
  private _nrxSaveUtils = inject(NRxSaveUtils);
  private _comnUtil = inject(CommonUtil);
  hasIframeInitialized: boolean = false;
  actnType: string;
  unsubscribe$: Subject<void> = new Subject();
  dateFrom = "1973-01-01";
  dateTo: string = null;
  pdmpNotesExists: boolean;
  orderedVendors: any;
  invokeType: string;
  errorModelRef: any;
  @ViewChild('errorPDMPModal', { static: true }) errorPDMPModal: any;
  errorMessage: any;
  isBambooDefault: boolean;
  popupId = uuid();
  @ViewChildren('vendorRadio') vendorRadios: QueryList<ElementRef>;
  @ViewChild('addNotesButton') addNotesButton: ElementRef;
  focusedIndex = 0;
  @Input() frmQuickRef: boolean = false;
  openOtherVendor: boolean;
  otherVendorDetails: any;
  displaySingleVendorOnly: boolean;
  otherVendorId: any;
  @ViewChild('openBtn') openBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('closeBtn') closeBtn!: ElementRef<HTMLButtonElement>;
  @HostListener("window:keydown", ["$event"])
  keyEvent(event: KeyboardEvent) {
      const topPopup = this._comnUtil.getTopPopup();
      if (event.which === 27 && topPopup === this.popupId) { // yes
          this.closeModal();
          event.preventDefault();
      }
  }
  constructor(private _notesLogSvc: NotesLogService) {}
  ngOnInit() {
    this.pdmpCheck();
  }


  async pdmpCheck() {
    let defaultVendor;
    this.pdmpVendorDetails = this._cmnStore.pdmpVendorConfigSetting$['source']['value'];
    const vendors = this.pdmpVendorDetails?.pdmpVendors ?? [];
    if (!this.otherVendorDetails) {
      // Get default vendor
      defaultVendor = vendors.find(v => v.isDefault);
      // Get remaining vendors
      const otherVendors = vendors.filter(v => !v.isDefault);
      // Final ordered list
      this.orderedVendors = defaultVendor ? [defaultVendor, ...otherVendors] : vendors;
    }
    this.vendorTypeId = this.otherVendorDetails ? this.otherVendorDetails.vendorId : (vendors?.length ? (vendors?.length === 1 ? vendors[0]?.vendorId : defaultVendor?.vendorId) : null);
    this.isBambooDefault = this.vendorTypeId === PDMPVendorEnums.Bamboo;
    try {
      // Fetch PDMP patient data
      const userResp = this._cmnService.loggedInUserDetails$["source"]["_value"];
      if(userResp) {
        this.pdmpVendorData = this._logicoy.logicoy(this.patientInfo, userResp, this.vendorTypeId === PDMPVendorEnums.Bamboo ? 'Bamboo' : 'Logicoy', true);
      } else {
        this.pdmpVendorData = await this._logicoy
        .newPDMPNow(this.patientInfo, this.vendorTypeId === PDMPVendorEnums.Bamboo ? 'Bamboo' : 'Logicoy').toPromise();
      }
      if (this.pdmpVendorData) {
        if (this.isBambooDefault) {
          // Check for missing required fields for Bamboo Health
          const pharmacistDetails = this.pdmpVendorData?.PharmacistDetails;
          const deanumber = pharmacistDetails?.DEANumber;
          const npinumber = pharmacistDetails?.NPINumber;
          const apprisLicenseNumber = pharmacistDetails?.ApprisLicenseNumber;
          if (!deanumber && !npinumber && !apprisLicenseNumber) {
            this.displayMissingFieldError();
            return;
          } else {
            this.displayPDMPVendorIframe();
          }
        } else {
          this.displayPDMPVendorIframe();
        }
      }
    }
    catch (err) {
    }
  }

  ngAfterViewInit() {
  // Focus default: first radio (Bamboo)
    setTimeout(() => {
      const first = this.vendorRadios.first?.nativeElement;
      if (first) first.focus();
      this.focusedIndex = 0;
    });
    setTimeout(() => {
      if (this.openOtherVendor && this.openBtn) {
        this.openBtn.nativeElement.focus();
      } else if (this.closeBtn) {
        this.closeBtn.nativeElement.focus();
      }
    });
  }
  ngAfterViewChecked() {
    setTimeout(() => {
      if (this.openOtherVendor && this.openBtn) {
        this.openBtn.nativeElement.focus();
      } else if (this.closeBtn) {
        this.closeBtn.nativeElement.focus();
      }
    });
  }
  async displayPDMPVendorIframe() {
    const payLoad = {
    vendorDetails: this.otherVendorDetails ? this.otherVendorDetails : this.pdmpVendorDetails?.pdmpVendors?.length ? (this.pdmpVendorDetails?.pdmpVendors?.length === 1 ? this.pdmpVendorDetails?.pdmpVendors[0] : this.pdmpVendorDetails?.pdmpVendors?.find(vendor => vendor.isDefault)) : this.pdmpVendorDetails?.pdmpVendors,
    patientRequest: this.pdmpVendorData
    };
    if (!this.frmPatOrRxHistory) {
      const searchParams = {
        SearchText: null,
        SearchBy: null,
        OrderByColumn: null,
        SortDirection: null,
        PageNumber: 1,
        PageSize: 30,
        PrescrefillId: null,
        IsFromPickup : false,
        DpvId: null
      };
      if (this.dateTo === null) {
        this.dateTo = moment(Date.now()).format("YYYY-MM-DD");
      }
      this._notesLogSvc
      .getNotesLog(
        "Rx",
        (this.rxType === "nr" || this.rxType === "nrf") ? 0 : this.rxInfo?.value["Prescription"]["Id"],
        this.dateFrom,
        this.dateTo,
        searchParams
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(resp => {
          const pdmpCatId = resp?.NoteCat?.length ? resp?.NoteCat?.find(cat => cat?.Name?.toUpperCase() === NotesMainCat.PDMP.toUpperCase())?.Id : null;

          if (pdmpCatId == null) {
            this.pdmpNotesExists = false;
          } else if (resp?.Note?.length) {
            this.pdmpNotesExists = resp.Note.some(note => note?.NoteCatId === pdmpCatId);
          } else {
            this.pdmpNotesExists = this.rxInfo?.value["RxNotes"]?.some(note => note?.NoteCatId === pdmpCatId );
          }
      });
    }
    this._cmnService.getPDMPCheckUrl(payLoad).subscribe(res => {
      if (res?.reportUrl) {
        this.narxInformation = res.narxDetails;
        this.vendorUrl = res.reportUrl;
        this.pdmpIframeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.vendorUrl);
        const defaultVendor = this.otherVendorDetails ? this.otherVendorDetails : this.pdmpVendorDetails?.pdmpVendors.find(v => v.isDefault);
        setTimeout(() => {
          this.invokeType = this.openType === 'manualInvoke' ? 'Manual Invoke' : 'Auto Invoke';
          this.trackLogs = this._rxStore.PdmpTrackLogs$['source']['value'] || [];
          if (this.pdmpVendorDetails?.pdmpVendors?.length > 1) {
            this.trackLogs.push({InvokeType: defaultVendor?.vendorId === this.pdmpVendorEnums.Logicoy ? 'Logicoy ('+ this.invokeType +')' : 'Bamboo Health ('+ this.invokeType +')', DateTime: new Date().toISOString()});
          } else {
            this.trackLogs.push({InvokeType: this.pdmpVendorDetails?.pdmpVendors[0]?.vendorId === this.pdmpVendorEnums.Logicoy ? 'Logicoy ('+ this.invokeType +')' : 'Bamboo Health ('+ this.invokeType +')', DateTime: new Date().toISOString()});
          }
          this._rxStore.storePdmpTrackLogs(this.trackLogs);
          this._loadrServ.display(true); // <-- SHOW LOADER HERE (until iframe loads)
          this._comnUtil.open(this.popupId);
          this.modelRef = this._modelService.open(this.pdmpVendorsDisplay, {
            backdrop: false,
            keyboard: false,
            centered: true,
            windowClass: this.rxType === "er" ? 'pdmp--modal--Expand' : 'pdmp-modal-center',
          });
        }, 0);
        this._loadrServ.display(true);
        if(defaultVendor?.vendorId === this.pdmpVendorEnums.Logicoy) {
          setTimeout(() => {
            this._loadrServ.display(false);
          }, (MsgConfig.Logicoy_Load_Timeout_MS));
        } else {
          setTimeout(() => {
            this._loadrServ.display(false);
          }, MsgConfig.BambooHealth_Load_Timeout_MS);
        }
      } else {
        if (!this.otherVendorDetails && this.pdmpVendorDetails?.pdmpVendors?.length > 1) {
          this.openOtherVendor = true;
          this.otherVendorDetails = this.pdmpVendorDetails?.pdmpVendors?.find(vendor => !vendor.isDefault);
          this.otherVendorId = this.otherVendorDetails?.vendorId;
        } else {
          this.openOtherVendor = false;
          this.otherVendorDetails = null;
          this.displaySingleVendorOnly = false;
          this.otherVendorId = null;
        }
        this.openErrorPrompt(res);
      }
    });
  }
  reOpenVendorReport() {
    if (this.errorModelRef) {
      this.errorModelRef.close();
      this.errorModelRef = null;
      this.errorMessage = null;
    }
    this.displaySingleVendorOnly = true;
    this.pdmpCheck();
  }


  closeModal(errorResponse?: any) {
    this.openOtherVendor = false;
    this.otherVendorDetails = null;
    this.displaySingleVendorOnly = false;
    this.otherVendorId = null;
    if (this.frmQuickRef && !this.frmPatOrRxHistory && this.trackLogs?.length && this.openType === 'autoInvoke') {
      this._nrxSaveUtils.savePDMPAuditLog(this.trackLogs, null, this.prescRefillId);
      this.trackLogs = [];
      this._rxStore.storePdmpTrackLogs([]);
    }
    if (!this.frmPatOrRxHistory && this.trackLogs?.length && this.openType === 'manualInvoke' && (this.rxType === 'er' || !this.rxType)) {
      this._nrxSaveUtils.savePDMPAuditLog(this.trackLogs, null, this.prescRefillId);
      this.trackLogs = [];
      this._rxStore.storePdmpTrackLogs([]);
    }
    if (this.modelRef) {
      this._comnUtil.close(this.popupId);
      this.modelRef.close();
      this.modelRef = null;
    }
    if (this.errorModelRef) {
      this.errorModelRef.close();
      this.errorModelRef = null;
      this.errorMessage = null;
    }
    if (errorResponse) {
      this.openErrorPrompt(errorResponse);
    }
    if (!errorResponse) {
      this.closeModalEvent.emit();
    }
  }

  openErrorPrompt(response: any) {
    this.errorMessage = response.message;
    this.pdmpIframeUrl = null;
    this.errorModelRef = this._modelService.open(this.errorPDMPModal, {
      backdrop: false,
      keyboard: false,
      centered: true,
      windowClass: this.errorMessage ? 'large-md--content' : '',
    });
  }
  async selectVendor(vendorType: string) {
    this._loadrServ.display(true);
    this.vendorTypeId = vendorType === 'bamboo' ? PDMPVendorEnums.Bamboo : PDMPVendorEnums.Logicoy;
    const userResp = this._cmnService.loggedInUserDetails$["source"]["_value"];
    if(userResp) {
      this.pdmpVendorData = this._logicoy.logicoy(this.patientInfo, userResp, vendorType === 'bamboo' ? 'Bamboo' : 'Logicoy', true);
    } else {
      this.pdmpVendorData = await this._logicoy
      .newPDMPNow(this.patientInfo, vendorType === 'bamboo' ? 'Bamboo' : 'Logicoy').toPromise();
    }
    if (this.pdmpVendorData) {
      if (vendorType === 'bamboo') {
        this.isBambooDefault = true;
        const pharmacistDetails = this.pdmpVendorData?.PharmacistDetails;
        const missing = !pharmacistDetails?.DEANumber && !pharmacistDetails?.NPINumber && !pharmacistDetails?.ApprisLicenseNumber;
        if (missing) {
          if (this.modelRef) {
            this.modelRef.close();
            this.modelRef = null;
          }
          this.displayMissingFieldError();
          this._loadrServ.display(false);
          return;
        }
      } else {
        this.isBambooDefault = false;
      }
      const vendorList = this.pdmpVendorDetails?.pdmpVendors ?? [];
      const vendorDetails = vendorList?.length === 1 ? vendorList[0] : vendorList?.find(v => v.vendorId === this.vendorTypeId);
      const payLoad = {
        vendorDetails: vendorDetails,
        patientRequest: this.pdmpVendorData
      };
      this._cmnService.getPDMPCheckUrl(payLoad).subscribe(res => {
        if (res?.reportUrl) {
          this.narxInformation = res.narxDetails;
          this.vendorUrl = res.reportUrl;
          this.trackLogs.push({InvokeType: vendorType === 'bamboo' ? 'Bamboo Health ('+ this.invokeType +')' : 'Logicoy ('+ this.invokeType +')', DateTime: new Date().toISOString()});
          setTimeout(() => {
            this._loadrServ.display(true);
            this.pdmpIframeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.vendorUrl);
            this._rxStore.storePdmpTrackLogs(this.trackLogs);
          }, 0);
          if(vendorType === 'bamboo') {
            setTimeout(() => {
              this._loadrServ.display(false);
            }, MsgConfig.BambooHealth_Load_Timeout_MS);
          } else {
            setTimeout(() => {
              this._loadrServ.display(false);
            }, MsgConfig.Logicoy_Load_Timeout_MS);
          }
        } else {
          this._loadrServ.display(false);
          this.closeModal(res);
        }
      });
    } else {
      this._loadrServ.display(false);
      return;
    }
  }
  openNotes() {
    this.actnType = 'Notes';
  }

  getNoteList(notesList) {
    if (notesList?.Note?.length) {
      const pdmpCatId = notesList.NoteCat
        ?.find(cat => cat?.Name?.toUpperCase() === NotesMainCat.PDMP.toUpperCase())
        ?.Id;
      this.pdmpNotesExists = notesList.Note.some(note => note?.NoteCatId === pdmpCatId);
    }
    if (this.rxInfo) {
      if(this.rxInfo.value["RxNotes"]?.length) {
        const rxNotes  = this.rxInfo.value["RxNotes"];
        rxNotes.concat(notesList.Note);
        this.rxInfo.controls["RxNotes"].patchValue(rxNotes);
      } else {
          this.rxInfo.controls["RxNotes"].patchValue(notesList.Note);
      }
    }
  }

  displayMissingFieldError() { //need to call for Bamboo Health when DEA, NPI, State License all missing before getting PDMP report check
    const modelMissingRef = this._modelService.open(CommonWarnorconfirmPopupComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: "large--content"
    });
    modelMissingRef.componentInstance.warnMsg = "To fetch the PDMP (<b>Bamboo Health</b>) report, please provide atleast one of the following user details: <b>DEA#</b>, <b>NPI#</b> or <b>State License#</b>.";
    modelMissingRef.componentInstance.includePath = true;
    modelMissingRef.componentInstance.okButton = true;
    modelMissingRef.componentInstance.IsPopUpClosed.subscribe((resp: any) => {
      if (modelMissingRef) {
        modelMissingRef.close();
      }
      this.closeModal();
    });
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  } 
  onRadioKeydown(event: KeyboardEvent, index: number) {
    const vendors = this.orderedVendors;
    // Tab: Move to next radio or Add Notes button
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      if (index < this.orderedVendors.length - 1) {
        // Focus next radio
        const radios = this.vendorRadios.toArray();
        this.focusedIndex = index + 1;
        const nextVendor = vendors[index + 1];
        // this.vendorTypeId = nextVendor?.vendorId;
        setTimeout(() => {radios[index + 1].nativeElement.focus();}, 2);
      } else {
        // Focus Add Notes button
        if (this.addNotesButton) {
          setTimeout(() => {this.addNotesButton.nativeElement.focus();}, 2);
        } else {
          this.focusedIndex = 0;
          const first = this.vendorRadios.first?.nativeElement;
          setTimeout(() => {if (first) first.focus();}, 2);
        }
      }
    }
    // Shift+Tab: Move to previous radio
    if (event.key === 'Tab' && event.shiftKey && index > 0) {
      event.preventDefault();
      const radios = this.vendorRadios.toArray();
      this.focusedIndex = index - 1;
      setTimeout(() => {radios[index - 1].nativeElement.focus();}, 2);
    }
    // Enter: Select vendor
    if (event.key === 'Enter') {
      event.preventDefault();
      const vendor = this.orderedVendors[index];
      this.selectVendor(vendor?.vendorId === this.pdmpVendorEnums?.Logicoy ? 'logicoy' : 'bamboo');
    }
  }

  onAddNotesKeydown(event: KeyboardEvent) {
    // Enter: Open notes
    if (event.key === 'Enter') {
      event.preventDefault();
      this.openNotes();
    }
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      if (this.vendorRadios && this.vendorRadios.length) {
        this.focusedIndex = 0;
        const first = this.vendorRadios.first?.nativeElement;
        setTimeout(() => {if (first) first.focus();}, 2);
      }
    }
    // Shift+Tab: Move focus to last radio
    if (event.key === 'Tab' && event.shiftKey) {
      event.preventDefault();
      if (this.vendorRadios && this.vendorRadios.length) {
        this.focusedIndex = this.orderedVendors.length - 1;
        setTimeout(() => {this.vendorRadios.toArray()[this.focusedIndex].nativeElement.focus();}, 2);
      }
    }
  }

  getSingleVendorLogo() {
    return this.otherVendorDetails ? this.otherVendorDetails.vendorId === this.pdmpVendorEnums?.Bamboo : this.pdmpVendorDetails?.pdmpVendors[0]?.vendorId === this.pdmpVendorEnums?.Bamboo;
  }
}

